import { render, staticRenderFns } from "./exportblk4b.vue?vue&type=template&id=62615b08"
import script from "./exportblk4b.vue?vue&type=script&lang=js"
export * from "./exportblk4b.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports